import { Admins } from '../admins/Admins';
import { AutoPay } from '../autopay/AutoPay';
import { AutoPaymentBatch } from '../autopay/AutoPaymentBatch';
import { AutoPayments } from '../autopay/AutoPayments';
import { BillingAccount } from '../billingAccounts/BillingAccount';
import { BillingAccounts } from '../billingAccounts/BillingAccounts';
import { MeterImages } from '../meterImages/MeterImages';
import { MeterImagesMini } from '../meterImages/MeterImagesMini';
import { MeterReads } from '../meterReads/MeterReads';
import { MeterRoutes } from '../routes/MeterRoutes';
import { Meters } from '../serviceAddresses/Meters';
import { MeterUsages } from '../serviceAddresses/MeterUsages';
import { ServiceAddresses } from '../serviceAddresses/ServiceAddresses';
import { withToast } from '../shared/Toast';
import IrisByType from '../stats/IrisByType';
import NumberOfActiveAccounts from '../stats/NumberOfActiveAccounts';
import { UVPAutoPayTabs } from '../uVPComponents/autopay/UVPAutoPayTabs';
import { PaymentFlow } from '../uVPComponents/paymentFlow/PaymentFlow';
import { ReportTabs } from '../uVPComponents/paymentReport/ReportTabs';
import { UVPReturnsTabs } from '../uVPComponents/returns/UVPReturnsTabs';
import { Wallet } from '../uVPComponents/wallet/Wallet';
import { RecurringReportTabs } from '../uVPComponents/recurringSignups/RecurringReportTabs';
import { BankReconcilationTabs } from '../uVPComponents/bankReconciliation/BankReconciliationTabs';
import { BillArchive } from '../uVPComponents/billArchive/BillArchive';

const Routes = [
    {
        path: "/app/admins",
        name: "Admins",
        Component: withToast(Admins)
    },
    {
        path: "/app/autopay",
        name: "Recurring Payments",
        Component: withToast(AutoPay)
    },
    {
        path: "/app/autopay/:paymentId/batch",
        name: "AutoPayment Batch",
        Component: withToast(AutoPaymentBatch)
    },
    {
        path: "/app/autopay/:paymentId",
        name: "Payments",
        Component: withToast(AutoPayments)
    },
    {
        path: "/app/billing-accounts",
        name: "Billing Accounts",
        Component: withToast(BillingAccounts)
    },
    {
        path: "/app/billing-accounts/:billingAccountId",
        name: "Billing Account",
        Component: withToast(BillingAccount)
    },
    {
        path: "/app/meter-images",
        name: "Meter Images",
        Component: withToast(MeterImages)
    },
    {
        path: "/app/meter-routes/:routeId/meter-images",
        name: "Meter Images",
        Component: withToast(MeterImagesMini)
    },
    {
        path: "/app/service-addresses/:serviceAddressId/meters/:meterId/meter-images",
        name: "Meter Images",
        Component: withToast(MeterImagesMini)
    },
    {
        path: "/app/meter-reads",
        name: "Meter Reads",
        Component: withToast(MeterReads)
    },
    {
        path: "/app/service-addresses/:serviceAddressId/meters/:meterId/meter-reads",
        name: "Meter Reads",
        Component: withToast(MeterReads)
    },
    {
        path: "/app/meter-routes",
        name: "Routes",
        Component: withToast(MeterRoutes)
    },
    {
        path: "/app/service-addresses",
        name: "Service Addresses",
        Component: withToast(ServiceAddresses)
    },
    {
        path: "/app/service-addresses/:serviceAddressId/meters",
        name: "Meters",
        Component: withToast(Meters)
    },
    {
        path: "/app/service-addresses/:serviceAddressId/meters/:meterId/usages",
        name: "MeterUsages",
        Component: withToast(MeterUsages)
    },
    {
        path: "/app/active-accounts",
        name: "Active Accounts",
        Component: withToast(NumberOfActiveAccounts)
    },
    {
        path: "/app/iris-stats",
        name: "Iris Stats",
        Component: withToast(IrisByType)
    },
    {
        path: "/app/payment-flow",
        name: "Payment Flow",
        Component: withToast(PaymentFlow)
    },
    {
        path: "/app/wallet",
        name: "Payment Flow",
        Component: withToast(Wallet)
    },
    {
        path: "/app/recurring",
        name: "Recurring Payments",
        Component: withToast(UVPAutoPayTabs)
    },
    {
        path: "/app/payment-report",
        name: "payment-report",
        Component: withToast(ReportTabs)
    },
    {
        path: "/app/returns",
        name: "chargebacks-returns",
        Component: withToast(UVPReturnsTabs)
    },
    {
        path: "/app/autopay-signups",
        name: "autopay-signups",
        Component: withToast(RecurringReportTabs)
    },
    {
        path: "/app/bank-reconciliation",
        name: "bank-reconciliation",
        Component: withToast(BankReconcilationTabs)
    },
    {
        path: "/app/bill-archive",
        name: "bill-archive",
        Component: withToast(BillArchive)
    }
]

export default Routes;